import { SUPPORT_EMAIL } from 'config';

import React, { Component } from 'react';

export default class ContactSupport extends Component {
  render() {
    return (
      <div {...this.props}>
        If the problem persists, please{' '}
        <a className="navy" href={`mailto:${SUPPORT_EMAIL}`}>
          contact support
        </a>.
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ContactSupport.jsx
 **/